import type { HTMLAttributes } from 'react';
import clsx from 'clsx';

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  tone?: 'info' | 'error' | 'success';
  /** When true, announces politely via aria-live (for async-surfaced messages). */
  live?: boolean;
}

export function Alert({ tone = 'info', live = false, className, children, ...rest }: AlertProps) {
  return (
    <div
      className={clsx('alert', `alert--${tone}`, className)}
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live={live ? 'polite' : undefined}
      {...rest}
    >
      {children}
    </div>
  );
}
